import { motion } from "framer-motion";
import { Card } from "@/components/ui/card";

export function PageHeader({ eyebrow, title, subtitle, actions, right, testid }) {
  // `right` is a defensive alias for `actions` — some pages historically
  // passed either name; accepting both prevents silent CTA drop.
  const rightSlot = actions ?? right;
  return (
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between mb-6 sm:mb-8 gap-3 sm:gap-4" data-testid={testid || "page-header"}>
      <div className="min-w-0">
        {eyebrow && <div className="overline mb-2">{eyebrow}</div>}
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-semibold font-display tracking-tight break-words">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-2 max-w-2xl">{subtitle}</p>}
      </div>
      {rightSlot && <div className="flex items-center gap-2 flex-wrap sm:shrink-0">{rightSlot}</div>}
    </div>
  );
}

export function StatCard({ label, value, hint, trend, icon: Icon, testid, accent = "orange" }) {
  const accents = {
    orange: "text-orange-400",
    green: "text-emerald-400",
    red: "text-rose-400",
    indigo: "text-indigo-400",
    zinc: "text-zinc-300",
  };
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}
      className="rounded-lg border border-white/10 dark:border-white/10 border-black/5 bg-card p-5 hover-lift"
      data-testid={testid}
    >
      <div className="flex items-start justify-between">
        <div className="overline">{label}</div>
        {Icon && <Icon className={"h-4 w-4 " + (accents[accent] || accents.orange)} />}
      </div>
      <div className="mt-3 text-3xl font-semibold font-display tabular-nums">{value}</div>
      {(hint || trend) && (
        <div className="mt-2 text-xs text-muted-foreground flex items-center gap-2">
          {trend && <span className={trend.up ? "text-emerald-400" : "text-rose-400"}>{trend.text}</span>}
          {hint && <span>{hint}</span>}
        </div>
      )}
    </motion.div>
  );
}

export function EmptyState({ title, hint, action }) {
  return (
    <Card className="border-dashed p-10 text-center">
      <div className="text-lg font-medium">{title}</div>
      {hint && <div className="text-sm text-muted-foreground mt-2">{hint}</div>}
      {action && <div className="mt-4 flex justify-center">{action}</div>}
    </Card>
  );
}
